import { ref, readonly } from 'vue';
import { defineStore } from 'pinia';
import { isAxiosError } from 'axios';
import type { Router } from 'vue-router';

export const useErrorStore = defineStore('error', () => {
  const isError = ref<boolean>(false);
  const statusCode = ref<number | undefined>(undefined);

  const handleError = (router: Router, err: unknown): void => {
    // eslint-disable-next-line no-console
    console.log(err);
    if (!isAxiosError(err) || !err.response) {
      statusCode.value = 500;
      isError.value = true;

      return;
    }

    if (err.response.status === 401 || err.response.status === 403) {
      router
        .push({
          path: '/auth/logout',
          query: { redirect: router.currentRoute.value.fullPath },
        })
        .catch(() => {
          statusCode.value = err.response?.status;
          isError.value = true;
        });

      return;
    }

    if (
      err.response.status === 404 ||
      err.response.data?.code === 'ORGANIZATION_ID_MISSING'
    ) {
      router
        .replace({
          name: 'notFound',
          params: { '0': router.currentRoute.value.path },
          hash: router.currentRoute.value.hash,
          query: router.currentRoute.value.query,
        })
        .catch(() => {
          statusCode.value = 404;
          isError.value = true;
        });

      return;
    }

    statusCode.value = err.response.status;
    isError.value = true;
  };

  const clearError = (): void => {
    isError.value = false;
    statusCode.value = undefined;
  };

  return {
    isError: readonly(isError),
    statusCode: readonly(statusCode),
    handleError,
    clearError,
  };
});
